<template>
  <div class="exhibitionRecord">
    <el-col class="subManage infoPub" style="width: 990px">
      <div class="exhContent">
        <div class="subManageTop">
          <!-- <el-tooltip class="item" effect="dark" :content="language.addChildAccountnotes" placement="top"> -->
            <el-button class="addBtn" type="primary" @click="addBtn">{{language.addChildAccount}}</el-button>
          <!-- </el-tooltip> -->
        </div>
        <!-- table -->
        <pub-table :columns="columns" :tableData="clonesubAccount" :loading="loading" :ticketMan="ticketMan">
          <template v-slot:email="dataList">
            <span v-if="dataList.row.user_type==1">{{dataList.row.email}}</span>
          </template>
          <!-- 操作按钮 -->
          <template v-slot:action="dataList">
            <div slot="action">
              <el-button
                    type="primary"
                    size="mini"
                    @click="selBtn(dataList.dataList)"
                    style="
                outline:none;heigth:26px;background:#f47900;border:none;color:#fff;border-radius:5px;font-size:14px">
                  {{language.edit}}</el-button>
              <el-button
                  type="primary"
                  size="mini"
                  @click="delBtn(dataList.dataList)"
                  style="
                outline:none;heigth:26px;background:#0071ff;border:none;color:#fff;border-radius:5px;font-size:14px">
                  {{language.delete}}</el-button>
            </div>
          </template>
        </pub-table>
        <!-- page -->
        <table-page
          :pageSize="pageSize"
          :layout="layout"
          :pageTotal="pageTotal"
          :currentPage="currentPage"
          @pageChange="pageChange"
        >
        </table-page>
      </div>
    </el-col>
    <!-- 添加子账号弹窗 -->
    <dialog-pub
      ref="dialogChild"
      title=""
      diaWidth="416px"
      :dialogFormVisible="dialogFormVisible"
      class="addChildren"
    >
      <div class="add-title" v-if="sub_user_id == ''">添加子账号</div>
      <div class="add-title" v-if="sub_user_id != ''">修改子账号</div>
      <el-form style="padding-top:16px;text-align:center" class="tickDialog">
        <el-form-item>
          <span><span style="color: red;">*</span>姓名：</span>
          <el-input style="width:280px;" v-model="userId" placeholder="请输入被添加人的姓名" />
        </el-form-item>
        <el-form-item>
          <span><span style="color: red;">*</span>职务：</span>
          <el-input style="width:280px" v-model="userPost" placeholder="请输入被添加人的职务" />
        </el-form-item>
        <el-form-item style="position: relative;left: -8px;">
          <span><span style="color: red;">*</span>手机号：</span>
          <el-input  style="width:280px" v-model="tel" placeholder="请输入被添加人的手机号" />
        </el-form-item>
        <el-form-item>
          <span><span style="color: red;">*</span>邮箱：</span>
          <el-input  style="width:280px" v-model="email" placeholder="请输入被添加人的邮箱" />
        </el-form-item>
        <div style="text-align:center">
          <div class="btnStyle"
               style="width: 220px;border-radius: 4px;background: #f47900;"
               @click="addSubaccountBtn">{{sub_user_id != "" ? language.save : language.add}}</div>
        </div>
      </el-form>
    </dialog-pub>
    <!-- 删除子账号 -->
      <dialog-pub
        ref="delDialogChild"
        title=""
        diaWidth="416px"
        :dialogFormVisible="delDialogRecycling"
        class="deletChildren"
      >
          <div class="tickDialog">
              <div style="text-align:center;margin:4px 0 60px 0;font-size:16px;color: #333333;">{{language.areYouSuretoDelete}}{{delUserName}}{{language.subAccount}}</div>
              <div style="text-align:center">
              <div
                class="btnStyle"
                style="margin:14px 36px 0 0;background:#2b6ff9;display: inline-block"
                @click="ok"
              >{{language.confirm}}</div>
              <div
              @click="cancel"
              class="btnStyle"
                style="margin-top:14px;background:#f2f2f2;display: inline-block;color: #333333;"
              >{{language.cancel}}</div>
              </div>
          </div>
      </dialog-pub>
  </div>
</template>
<script>
import { language } from "../../../language/get";
import Cookie from "../../../common/cookie"
import { getSubAccount,addSubAccount,delSubAccount } from "../../../api/subAccount";
import pubTable from "../components/table/table";
import tablePage from "../components/tablepage/tablepage";
import dialogPub from "../components/dialogpub/dialogpub";
import {mapGetters} from "vuex";
const pubLanguage = language();
export default {
  components: {
    pubTable,
    tablePage,
    dialogPub
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  data() {
    return {
      ticketMan:true,
      language:language(),
      lan: Cookie.get("lang"),
      userId: "",
      userPost:"",
      sub_user_id:"",
      tel:"",
      email:"",
      title: pubLanguage.addSubaccount,
      deletTitle:pubLanguage.delete1,
      delUserId:'',
      delUserName:'',
      dialogFormVisible: false,
      delDialogRecycling:false,
      loading: true,
      pageTotal: 0,
      pageSize: 6,
      currentPage: 1,
      layout: "prev, pager, next, jumper",
      //table 表头
      columns: [
        {
          title: pubLanguage.name,
          key: "true_name",
          width: "193"
        },
        {
          title: pubLanguage.userPost,
          key: "user_post",
          width: "193"
        },
        {
          title: pubLanguage.mobilePhone,
          key: "tel",
          width: "193"
        },
        {
          title: pubLanguage.email,
          key: "email",
          width: "196"
        },
        {
          title: pubLanguage.operation,
          key: "action",
          width: "193"
        }
      ],
      subAccount: [],
      clonesubAccount: []
    };
  },
  created() {
    this.gsubAccount();
    console.log("添加" , this.userInfo);
  },
  methods: {
    //添加
    addBtn(){
      if(this.userInfo.superioruser_id != 0) {
        const height = document.body.clientHeight / 2;
        this.$message.error({message:"子账号不能添加子账号", offset:height})
      }else {
        this.sub_user_id = '';
        this.userId = '';
        this.userPost = '';
        this.email = '';
        this.tel='';
        this.$refs.dialogChild.receiveDialogFormVisible = true
      }

    },
    //删除
    delBtn(val){
      this.delUserId = val.user
      this.delUserName = val.true_name
      this.$refs.delDialogChild.receiveDialogFormVisible = true
    },
    selBtn(val) {
      this.sub_user_id = val.user_id;
      this.userId = val.true_name;
      this.userPost = val.user_post;
      this.email = val.email;
      this.tel = val.tel;
      this.$refs.dialogChild.receiveDialogFormVisible = true
      console.log("====" , val);
    },
    ok(){
      let data = {
        token:this.$store.state.user.token,
        user_num:this.delUserId,
      }
      delSubAccount(data).then(res => {
        const height = document.body.clientHeight / 2;
          if(res.type == '1'){
             this.$message({
                message: this.language.delSuccess,
                type: 'success',
                offset:height
              });
              this.$refs.delDialogChild.receiveDialogFormVisible = false
              this.gsubAccount();
           }else{
            if (this.lan == "ch") {
              return this.$message.error({message: res.text, offset: height})
            }
            return this.$message.error({message: res.text_en, offset: 120})
           }
      })
    },
    cancel(){
      this.$refs.delDialogChild.receiveDialogFormVisible = false
    },
    //添加子账号
    addSubaccountBtn(){
        let data = {
          // token:this.$store.state.user.token,
          // user_num:this.userId
          tel:this.tel,
          email:this.email,
          true_name:this.userId,
          user_post:this.userPost,
          sub_user_id:this.sub_user_id,
          user_id:this.userInfo.user_id
        }
        addSubAccount(data).then(res => {
          const height = document.body.clientHeight / 2;
           if(res.type == '1'){
             if(this.sub_user_id == "") {
               this.$message({
                 message: this.language.addSuccess,
                 type: 'success',
                 offset:height
               });
             }else{
               this.$message({
                 message: this.language.chanceSuccess,
                 type: 'success',
                 offset:height
               });
             }

              this.$refs.dialogChild.receiveDialogFormVisible = false
              this.gsubAccount();
           }else{
             if (this.lan == "ch") {
               return this.$message.error({message: res.text, offset: height})
             }
             return this.$message.error({message: res.text_en, offset: 120})
           }
        })
    },
    //分页
    pageChange(val) {
      this.currentPage = val;
      this.gsubAccount();
    },
    //分页截取数据
    getNewData() {
      let start = (this.currentPage - 1) * this.pageSize;
      let end = this.currentPage * this.pageSize;
      this.clonesubAccount = this.subAccount.slice(start, end);
    },
    //子账户列表
    gsubAccount() {
      let that = this;
      let data = {
        token: this.$store.state.user.token,
        currentPage:this.currentPage,
        numberPage:this.pageSize,
      };
      getSubAccount(data).then(res => {
        if (res.type == "1") {
          if (!res.data) {
            this.subAccount = [];
            this.clonesubAccount = [];
            this.pageTotal = res.datacount;
            this.loading = false;
            return false;
          }

          for(let item of res.data){
            item.company_en = (item.company_en || item.company) || '-';
            item.company = (item.company || item.company_en) || '-';
            item.location_en = (item.location_en || item.location) || '-';
            item.location = (item.location || item.location_en) || '-';
            item.user_post = (item.user_post || item.user_post_en) || '-';
            item.user_post_en = (item.user_post_en || item.user_post) || '-';
            item.true_name_en = (item.true_name_en || item.true_name) || '-';
            item.true_name = (item.true_name || item.true_name_en) || '-';

            if (this.lan == "en") {
              item.company=item.company_en?item.company_en:"-";
              item.location=item.location_en?item.location_en:"-"
              item.true_name=item.true_name_en?item.true_name_en:"-"
              item.user_post=item.user_post_en?item.user_post_en:"-"

            }
            item.email=item.email?item.email:"-"
            item.tel=item.tel?item.tel:"-"
            item.tel_phone=item.tel_phone?item.tel_phone:"-"
          }


          this.subAccount = res.data;
          this.clonesubAccount = res.data
          this.pageTotal = res.datacount;
          this.loading = false;
        } else {
          if (this.lan == "ch") {
            const height = document.body.clientHeight / 2;
            return this.$message.error({message: res.text, offset: height})
          }
          return this.$message.error({message: res.text_en, offset: 120})
        }

      });
      console.log("子账号" , this.clonesubAccount);
    }
  }
};
</script>
<style scoped>
  .btnStyle{
    width: 120px;
    height: 40px;
    background-color: #f4a100;
    border-radius: 8px;
    text-align: center;
    margin: auto;
    font-family: MicrosoftYaHeiLight;
    font-size: 14px;
    color: #ffffff;
    line-height: 40px;
    cursor: pointer;
  }
</style>
<style>
.add-title {
  width: 343px;
  color: #333333;
  font-size: 24px;
  font-weight: 600;
  margin: 0 auto;
  text-align: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #CCCCCC;
}
.addChildren .formCon {
  padding: 0;
}
.dislogCon .el-dialog__header .el-dialog__title{
  font-size: 20px!important;
  /*font-weight: bold;*/
  color: rgb(51, 51, 51);
}
.subManage .subManageTop {
  background: transparent;
  height: 40px;
  padding: 10px 10px 10px 0;
}
.subManage .addBtn {
  padding: 13px 15px;
  height: 40px;
  font-size: 14px;
  color: #ffffff;
  background: #0071ff;
  border: none;
  float: left;
  /* padding: 0; */
}
  .dialog_hint_text {
    font-size: 14px;
    color: #a1a1a1;
  }
  .addChildren .el-dialog .el-dialog__header {
    height: 20px !important;
    border: none;
  }
  .addChildren .el-input__inner {
    border: none !important;
  }
  .child-name {
    text-align: right;
    width: 10px;
  }
  .deletChildren .el-dialog__header {
    text-align: center !important;
    font-size: 24px !important;
    color: #333333 !important;
    border: none !important;
    height: 36px !important;
  }
.subManage .page{
  margin-left: 0;
}
.deletChildren .formCon {
  padding-top:0 ;
}

</style>
